<template>
  <v-dialog
    :value="dialog"
    @input="setDialogAction(!dialog)"
    scrollable
    width="80vw"
    style="min-height: 100%"
    content-class="v-dialog-right v-dialog-width"
    transition="slide-x-reverse-transition">
    <v-card class="glass-effect rounded-0" min-height="100vh">
      <v-toolbar
        elevation="0"
        max-height="65px"
        dark
        :color="$store.state.achievement.side_color"
      >
        <v-btn
          icon
          dark
          @click="setDialogAction(false)"
        >
          <v-icon>fa fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>{{ payload.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="typeBtnFormAchievement"
          >
            <v-icon class="pr-2">fa fa-save</v-icon>
            Сохранить
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pa-0 ma-0 px-1 overflow-auto">
        <v-card elevation="0">
          <v-card-text>
            <v-form ref="form-achievement-kind">
              <v-row>
                <v-col cols="12" sm="5">
                  <section-edit-achievement/>
                </v-col>
                <v-col cols="12" sm="7">
                  <section-edit-unit/>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import SectionEditAchievement from "../Forms/SectionEditAchievement";
import SectionEditLevel from "../Forms/SectionEditAchievement/SectionEditLevel";
import SectionEditUnit from "../Forms/SectionEditAchievement/SectionEditUnit";
import axios from "axios";

export default {
  name: "FormSettingAchievement",

  components: {
    SectionEditAchievement,
    SectionEditLevel,
    SectionEditUnit
  },

  data() {
    return {
      tab: "nonLevel",
    };
  },

  computed: {
    ...mapState({
      dialog: state => state.achievement_kind.dialog,
      edit_mode_form: state => state.achievement_kind.edit_mode_form,
      payload: state => state.achievement_kind.payload,
    }),

    typeBtnFormAchievement() {
      if (this.edit_mode_form) return () => this.updateBtn();
      else return () => this.createBtn();
    },

  },

  watch: {

  },

  methods: {
    ...mapMutations({
      setDialog: 'achievement_kind/setDialog',
    }),

    ...mapActions({
      setDialogAction: 'achievement_kind/setDialogAction',
      createAchievementKind: 'achievement_kind/createAchievementKind',
      updateAchievementKind: 'achievement_kind/updateAchievementKind',
    }),

    async createBtn() {
      if (this.$refs["form-achievement-kind"].validate()) {
        await this.createAchievementKind();
      }
    },

    async updateBtn() {
      if(this.$refs["form-achievement-kind"].validate()) {
        await this.updateAchievementKind();
      }
    },

  },
}
</script>

<style scoped>
.v-dialog {
  backdrop-blur: 20px;
}

>>> .v-dialog-right {
  position: absolute;
  border-radius: 0;
  margin: 0;
  padding: 0;
  height: 100%;
  min-height: 100%;
  overflow-y: auto;
  top: 0;
  right: 0;
}
</style>